import React, { useState } from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faIndustry, faUsersCog, faShoppingCart, faWarehouse,
  faTruck, faHandHoldingUsd, faCogs, faRobot,
  faScrewdriverWrench, faClipboardCheck
} from "@fortawesome/free-solid-svg-icons";
import SyntraMfgMetaverseStakeholderModal from "./SyntraMfgMetaverseStakeholderModal";

const stakeholders = [
  { icon: faIndustry, label: "Manufacturers", info: "Upload product listings, showcase factories." },
  { icon: faUsersCog, label: "Workforce", info: "Skilled/unskilled workers, training & jobs." },
  { icon: faShoppingCart, label: "Buyers", info: "Browse and purchase industrial goods." },
  { icon: faWarehouse, label: "Warehousing", info: "Inventory, storage and smart warehouses." },
  { icon: faTruck, label: "Logistics", info: "Transport raw materials & finished goods." },
  { icon: faHandHoldingUsd, label: "Finance", info: "Credit, insurance & investment services." },
  { icon: faCogs, label: "Suppliers", info: "Raw material and component supply." },
  { icon: faRobot, label: "Automation", info: "Robotics & AI-driven solutions." },
  { icon: faScrewdriverWrench, label: "Maintenance", info: "Machine servicing and technical support." },
  { icon: faClipboardCheck, label: "Quality & Compliance", info: "Testing, certifications & audits." },
];

const SyntraMfgMetaverseStakeholdersGrid = () => {
  const [selected, setSelected] = useState(null);

  return (
    <div>
      <motion.div
        className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 w-full max-w-5xl mx-auto"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5, duration: 1 }}
      >
        {stakeholders.map((s, i) => (
          <motion.div
            key={i}
            className="bg-white p-4 rounded-2xl shadow-md flex flex-col items-center cursor-pointer hover:shadow-xl"
            whileHover={{ scale: 1.05 }}
            onClick={() => setSelected(s)}
          >
            <FontAwesomeIcon icon={s.icon} className="text-blue-700 text-3xl mb-2" />
            <span className="font-medium text-blue-900">{s.label}</span>
          </motion.div>
        ))}
      </motion.div>

      {selected && (
        <SyntraMfgMetaverseStakeholderModal
          stakeholder={selected}
          onClose={() => setSelected(null)}
        />
      )}
    </div>
  );
};

export default SyntraMfgMetaverseStakeholdersGrid;
